import { Box, Tabs, TabList, Tab } from '@chakra-ui/react'

export function Header({ tabs, currentTab, onTabChange }) {
  const currentTabIndex = tabs.findIndex((tab) => tab.id === currentTab.id)

  const handleTabChange = (index) => {
    if (onTabChange) {
      onTabChange(tabs[index])
    }
  }

  return (
    <Box w="100%" borderBottom="1px solid" borderColor="gray.200">
      <Tabs variant="unstyled" index={currentTabIndex !== -1 ? currentTabIndex : 0} onChange={handleTabChange}>
        <TabList>
          {tabs.map((tab) => (
            <Tab
              key={tab.id}
              _selected={{
                color: 'black',
                fontWeight: '600',
                position: 'relative',
                _after: {
                  content: '""',
                  position: 'absolute',
                  bottom: '-1px',
                  left: 0,
                  right: 0,
                  height: '2px',
                  bg: '#378BBF',
                  borderRadius: '1px',
                },
              }}
              _focus={{
                outline: 'none',
                boxShadow: 'none',
              }}
              fontSize="14px"
              color="gray.500"
              fontWeight="400"
              px={4}
              py={2}
              mr={2}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
      </Tabs>
    </Box>
  )
}
